import { OpaqueToken, NgModule } from '@angular/core';

export const /** @type {?} */ AN_DYNAMIC_COMPONENT_MODULE = new OpaqueToken('AN_DYNAMIC_COMPONENT_MODULE');
/**
 * @param {?} metadata
 * @return {?}
 */
export function provideAnDynamicComponentModule(metadata: NgModule): Array<any> {
  return [ { provide: AN_DYNAMIC_COMPONENT_MODULE, useValue: metadata } ];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
